var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "city-contact" }, [
    _c("h3", { staticClass: "city-name" }, [
      _vm.city === _vm.positionCity || _vm.city + "市" === _vm.positionCity
        ? _c("i", { staticClass: "icon icon-s-location" })
        : _vm._e(),
      _vm._v(" "),
      _c("span", { domProps: { textContent: _vm._s(_vm.city) } }),
      _vm._v(" "),
      _vm.city === _vm.positionCity || _vm.city + "市" === _vm.positionCity
        ? _c("span", [_vm._v("-当前城市")])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "contact-people-list" },
      [
        _vm.city === "上海" && _vm.has2500
          ? _c("div", { staticClass: "contact-people" }, [_vm._m(0)])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.lists, function(list) {
          return _c("div", { staticClass: "contact-people" }, [
            _c(
              "a",
              {
                staticClass: "contact-tel-wrap flexBox",
                attrs: { href: "tel:" + list.Mobile }
              },
              [
                _c("img", {
                  staticClass: "contact-avator",
                  attrs: {
                    src: list.HeadImg,
                    onerror:
                      "this.onerror=null;this.src='../../static/images/default.png'"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "contact-info flexItem" }, [
                  _c("p", {
                    staticClass: "account",
                    domProps: { textContent: _vm._s(list.Name) }
                  }),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "remark",
                    domProps: { textContent: _vm._s(list.Remarks) }
                  }),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "location",
                    domProps: { textContent: _vm._s(list.Location) }
                  })
                ]),
                _vm._v(" "),
                _c("i", { staticClass: "icon icon-telephone" })
              ]
            )
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "contact-tel-wrap flexBox",
        attrs: { href: "tel:021-6908-2500" }
      },
      [
        _c("img", {
          staticClass: "contact-avator",
          attrs: { src: require("../../static/images/2500_avator.png") }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "contact-info flexItem" }, [
          _c("p", { staticClass: "account" }, [_vm._v("2500服务台")]),
          _vm._v(" "),
          _c("p", { staticClass: "location" }, [_vm._v("Shanghai")])
        ]),
        _vm._v(" "),
        _c("i", { staticClass: "icon icon-telephone" })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-3b9d1ffe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3b9d1ffe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/contactList.vue
// module id = null
// module chunks = 